export function validateString(maybeString: unknown): string {
  if (typeof maybeString !== 'string') {
    throw new Error(
      `Expected value to be a string, but received ${typeof maybeString}.`,
    );
  }
  return maybeString;
}
